import {Observable} from 'rxjs';
import {CollectionViewer} from '@angular/cdk/collections';
import {DataSource} from '@angular/cdk/table';

export class EntityDataSource<T> extends DataSource<T> {
    constructor(private _entityList$: Observable<T[]>) {
        super();
    }

    connect(collectionViewer: CollectionViewer): Observable<T[]> {
        return this._entityList$;
    }

    disconnect(collectionViewer: CollectionViewer): void {}
}
